import type { ProductFlatten } from "~/types";

export function Categories({ product }: { product: ProductFlatten }) {
  return (
    <nav aria-label="Categories" className="float-right pt-1 lg:float-left lg:pt-0">
      <ol className="flex max-w-2xl items-center space-x-2 lg:max-w-7xl" id="olCategories">
        {product.collections?.map((collection, index) => (
          <li key={index}>
            <div className="flex items-center">
              <a
                href={`/category/${collection.handle}`}
                className="mr-2 text-sm font-semibold text-gray-400 hover:text-admirerBlue md:font-bold"
              >
                {collection.title}
              </a>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
